export default __webpack_public_path__ + "static/0085-78c593e529e0bb5c1c44e02943b5ffe2.png";